import { analyticsEventLabel, type TAnalyticsMyRequirementBE } from '@onesource/schemas';
import { MdCheckCircle, MdErrorOutline, MdPlayArrow, MdSchedule } from 'react-icons/md';

type ChipColor = 'default' | 'primary' | 'success' | 'warning' | 'error';
type ChipVariant = 'filled' | 'outlined';

export interface RequirementDisplay {
  icon: JSX.Element;
  label: string;
  color: ChipColor;
  variant: ChipVariant;
}

/** Status chip for a requirement row — same vocabulary as the lesson progress chips. */
export const getRequirementDisplay = (req: TAnalyticsMyRequirementBE): RequirementDisplay => {
  if (req.met) {
    return { icon: <MdCheckCircle size={16} />, label: 'Completed', color: 'success', variant: 'filled' };
  }
  if (req.overdue) {
    return { icon: <MdErrorOutline size={16} />, label: 'Overdue', color: 'error', variant: 'filled' };
  }
  if (req.value > 0 || (req.progress?.completed ?? 0) > 0) {
    return { icon: <MdSchedule size={16} />, label: 'In progress', color: 'warning', variant: 'filled' };
  }
  // Grey on purpose: red is reserved for Overdue.
  return { icon: <MdPlayArrow size={16} />, label: 'Start', color: 'default', variant: 'outlined' };
};

/** Shared with the admin builder so members read the same wording (e.g. "Joined live or watched replay"). */
export const prettifyEvent = analyticsEventLabel;
